module.exports = __webpack_public_path__ + "static/media/vest2.c4c10f96.JPG";